


















































































































































































































































































































































































































import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import CaseFoldingCard from '@/modules/Newcase/components/CaseFoldingCard.vue'
import dollarFilter from '@/utils/dollarFilter'
import { dateToDisplay, dateTimeToDisplay } from '@/utils/dateTime'
import AssetVehicleDialog from '@/modules/AccountAsset/scripts/asset-vehicle-dialog'
import AssetPropertyDialog from '@/modules/AccountAsset/scripts/asset-property-dialog'
import { Policy } from '@/modules/Policy/interfaces/policy'
import {
  policyStatus, billingType, payerType, policyStatusClass, statusValues, billingTypeValues, policyType
} from '@/modules/Policy/helpers/policy'
import { caseTypeToVerb } from '@/modules/Case/helpers/case'
import AppCheckbox from '@/components/AppCheckbox.vue'
import { showErrors, showNotification } from '@/utils/snack'
import { updatePolicyNonRenew, updatePolicyCancelDate } from '@/modules/Policy/gql/policy.gql'
import { SnackType } from '@/interfaces/snack'
import AppDatePicker from '@/components/AppDatePicker.vue'
import PolicyDialog from '../../Policy/scripts/policy-dialog'
import { CaseReview } from '@/modules/Newcase/interfaces/case-review'

@Component({
  components: {
    CaseFoldingCard,
    AppCheckbox,
    AppDatePicker
  }
})
export default class CasePolicyInfo extends mixins(AssetVehicleDialog, AssetPropertyDialog, PolicyDialog) {
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy
  @Prop({ type: Boolean }) readonly unFolding!: Boolean
  @Prop({ type: Object as () => CaseReview }) readonly review!: CaseReview

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  caseTypeToVerb = caseTypeToVerb
  dollarFilter = dollarFilter
  policyStatus = policyStatus
  billingType = billingType
  payerType = payerType
  billingTypeOptions = billingTypeValues
  policyStatusClass = policyStatusClass
  statusOptions = statusValues
  policyType = policyType

  nonRenewDialog = {
    show: false
  }

  autoCancelDialog = {
    show: false
  }

  policyInput: {
    [key: string]: any;
  } = {
    nonRenew: false,
    autoCancel: false,
    cancelDate: ''
  }

  get premiumType () {
    return this.policy.generalAgent
      ? 'ga'
      : 'direct'
  }

  get priorTermRoute () {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: this.policy.inheritPolicies.fromPolicy
          ? this.policy.inheritPolicies.fromPolicy.id
          : null
      }
    }
  }

  get postTermRoute () {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: this.policy.inheritPolicies.toPolicy
          ? this.policy.inheritPolicies.toPolicy.id
          : null
      }
    }
  }

  get quoteRoute () {
    return {
      name: 'QuoteDetailDetail',
      params: {
        id: this.policy.insuranceQuote.id
      }
    }
  }

  get accountRoute () {
    return {
      name: 'AccountDetailDetail',
      params: {
        id: this.policy.account.id
      }
    }
  }

  get contactRoute () {
    return {
      name: 'ContactDetailDetail',
      params: {
        id: this.policy.primaryContact.id
      }
    }
  }

  get totalProjectedPremium () {
    let totalNum = 0
    if (this.policy) {
      const { premium, agencyFee, carrierPolicyFee, inspectionFee, stampingFee, taxesFee, brokerFee } = this.policy
      const premiumNum = premium ? Number(premium) : 0
      const agencyFeeNum = agencyFee ? Number(agencyFee) : 0
      const carrierPolicyFeeNum = carrierPolicyFee ? Number(carrierPolicyFee) : 0
      const inspectionFeeNum = inspectionFee ? Number(inspectionFee) : 0
      const stampingFeeNum = stampingFee ? Number(stampingFee) : 0
      const taxesFeeNum = taxesFee ? Number(taxesFee) : 0
      const brokerFeeNum = brokerFee ? Number(brokerFee) : 0
      totalNum = Number((premiumNum + agencyFeeNum + carrierPolicyFeeNum + inspectionFeeNum + stampingFeeNum + taxesFeeNum + brokerFeeNum).toFixed(2))
    }
    return totalNum
  }

  get totalProjectedCommission () {
    let totalNum = '0.00'
    if (this.policy) {
      const { premium, productCommissionOverride } = this.policy

      if (premium && productCommissionOverride && !isNaN(Number(productCommissionOverride))) {
        totalNum = (Number(premium) * Number(productCommissionOverride) / 100).toFixed(2)
      }
    }
    return totalNum
  }

  async mounted () {
    this.policyInput.nonRenew = this.policy.nonRenew
    this.policyInput.autoCancel = this.policy.shouldAutoCancel
    this.policyInput.cancelDate = this.policy.cancelDate
  }

  async updateNonRenewPost () {
    const {
      nonRenew
    } = this.policyInput

    this.nonRenewDialog.show = false

    try {
      const res = await this.$apollo.mutate({
        mutation: updatePolicyNonRenew,
        variables: {
          policyId: Number(this.policy.id),
          nonRenew
        }
      })
      showNotification({
        msg: 'Update policy "non-renew" successfully',
        type: SnackType.Success
      })
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async updateAutoCancelPost () {
    const {
      autoCancel,
      cancelDate
    } = this.policyInput

    if (autoCancel) {
      const autoCancelValid = (this.$refs.autoCancel as Vue & { validate: () => boolean }).validate()

      if (!autoCancelValid) {
        return
      }
    }

    this.autoCancelDialog.show = false

    try {
      const res = await this.$apollo.mutate({
        mutation: updatePolicyCancelDate,
        variables: {
          policyId: Number(this.policy.id),
          autoCancel,
          cancelDate: cancelDate ? cancelDate.toString() : ''
        }
      })
      showNotification({
        msg: 'Update policy auto cancel date successfully',
        type: SnackType.Success
      })
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  routeToDetail () {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: this.policy.id
      }
    }
  }

  clearPolicyInput () {
    this.policyInput = {
      nonRenew: false,
      autoCancel: false,
      cancelDate: ''
    }
  }

  editPolicy (step: number) {
    this.policyInfoDialog.title = 'Edit Policy'
    this.policyInfoDialog.actionType = 'edit'
    this.policyInfoDialog.step = step
    this.policyInfoDialog.show = true
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }
}
